/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  $.each(window.DeskTrustBar || {}, function (sectionId) {
    var section = document.getElementById('shopify-section-' + sectionId);
    if (!section) return;

    var $section = $(section);

    function isMobile() {
      return window.innerWidth <= 799;
    }

    $section.on('click', '.trust-bar__item-header', function () {
      if (!isMobile()) return;

      var $item = $(this).closest('.trust-bar__item');
      var $desc = $item.find('.trust-bar__desc');
      if (!$desc.length) return;

      $desc.slideToggle(300);
      $item.find('.trust-bar__arrow').toggleClass('is-open');
    });
  });
});
